// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.details {
  width: 100%;
  align-self: baseline;
}
.details .items > *:not(:last-child) {
  margin-bottom: 1rem;
}
.details .items > *:last-child {
  margin-bottom: 0.5rem;
}

.summary > *:first-child {
  border-top: var(--border-divider);
}

.total {
  margin-top: 0.5rem;
  border-top: var(--border-divider);
}

.small {
  font-size: var(--font-secondary);
  color: var(--color-secondary);
}

.w30p {
  width: 30px;
}

.w40p {
  width: 40px;
}

.w50p {
  width: 50px;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImludm9pY2UtY29zdC1kZXRhaWxzLmNvbXBvbmVudC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsV0FBQTtFQUNBLG9CQUFBO0FBQ0Y7QUFDRTtFQUNELG1CQUFBO0FBQ0Q7QUFFRTtFQUNELHFCQUFBO0FBQUQ7O0FBSUE7RUFDRSxpQ0FBQTtBQURGOztBQUlBO0VBQ0Usa0JBQUE7RUFDQSxpQ0FBQTtBQURGOztBQUlBO0VBQ0UsZ0NBQUE7RUFDQSw2QkFBQTtBQURGOztBQUlBO0VBQ0UsV0FBQTtBQURGOztBQUlBO0VBQ0UsV0FBQTtBQURGOztBQUdBO0VBQ0UsV0FBQTtBQUFGIiwiZmlsZSI6Imludm9pY2UtY29zdC1kZXRhaWxzLmNvbXBvbmVudC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLmRldGFpbHN7XG4gIHdpZHRoOiAxMDAlO1xuICBhbGlnbi1zZWxmOiBiYXNlbGluZTtcblxuICAuaXRlbXMgPiAqOm5vdCg6bGFzdC1jaGlsZCl7XG5cdG1hcmdpbi1ib3R0b206IDFyZW07XG4gIH1cblxuICAuaXRlbXMgPiAqOmxhc3QtY2hpbGR7XG5cdG1hcmdpbi1ib3R0b206IDAuNXJlbTtcbiAgfVxufVxuXG4uc3VtbWFyeSA+ICo6Zmlyc3QtY2hpbGR7XG4gIGJvcmRlci10b3A6IHZhcigtLWJvcmRlci1kaXZpZGVyKTtcbn1cblxuLnRvdGFse1xuICBtYXJnaW4tdG9wOiAwLjVyZW07XG4gIGJvcmRlci10b3A6IHZhcigtLWJvcmRlci1kaXZpZGVyKTtcbn1cblxuLnNtYWxse1xuICBmb250LXNpemU6IHZhcigtLWZvbnQtc2Vjb25kYXJ5KTtcbiAgY29sb3I6IHZhcigtLWNvbG9yLXNlY29uZGFyeSk7XG59XG5cbi53MzBwe1xuICB3aWR0aDogMzBweDtcbn1cblxuLnc0MHB7XG4gIHdpZHRoOiA0MHB4O1xufVxuLnc1MHB7XG4gIHdpZHRoOiA1MHB4O1xufVxuIl19 */`, "",{"version":3,"sources":["webpack://./src/app/components/common/invoice-cost-details/invoice-cost-details.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,oBAAA;AACF;AACE;EACD,mBAAA;AACD;AAEE;EACD,qBAAA;AAAD;;AAIA;EACE,iCAAA;AADF;;AAIA;EACE,kBAAA;EACA,iCAAA;AADF;;AAIA;EACE,gCAAA;EACA,6BAAA;AADF;;AAIA;EACE,WAAA;AADF;;AAIA;EACE,WAAA;AADF;;AAGA;EACE,WAAA;AAAF;AACA,4rCAA4rC","sourcesContent":[".details{\n  width: 100%;\n  align-self: baseline;\n\n  .items > *:not(:last-child){\n\tmargin-bottom: 1rem;\n  }\n\n  .items > *:last-child{\n\tmargin-bottom: 0.5rem;\n  }\n}\n\n.summary > *:first-child{\n  border-top: var(--border-divider);\n}\n\n.total{\n  margin-top: 0.5rem;\n  border-top: var(--border-divider);\n}\n\n.small{\n  font-size: var(--font-secondary);\n  color: var(--color-secondary);\n}\n\n.w30p{\n  width: 30px;\n}\n\n.w40p{\n  width: 40px;\n}\n.w50p{\n  width: 50px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
